export default __webpack_public_path__ + "disney.56649712.png";